import { ItiMessageService } from "@/iti-core-react/services/iti-message-service.ts";
import { UploadStatus } from "@/shared/enums/upload-status";
import { t } from "i18next";
import { artifactUploaderActions } from "./artifactUploaderAction";

/**
 * Extrae el streamingId de la respuesta del servicio de calidad
 */
export const extractStreamingId = (response: any): string | undefined => {
	if (typeof response === "string") {
		return response;
	}
	return response?.sessionId || response?.streamingId || response?.id;
};

/**
 * Maneja errores durante el proceso de upload
 */
export const handleUploadError = (
	dispatch: any,
	artifact: any,
	fileName: string,
	datasetId: string,
	displayName: string,
	_error: any,
	stage?: "creation" | "upload" | "consolidation" | "analysis",
): void => {
	if (stage === "consolidation") {
		ItiMessageService.toastError(
			t("catalogue.uploaded-error", { file: displayName }).toString(),
		);
	}

	dispatch(
		artifactUploaderActions.artifactProcessed({
			id: artifact.artifactId || artifact.Id || "UNKNOWN_ID",
			datasetId: datasetId,
			fileName: fileName,
			status: UploadStatus.UPLOADING_ERROR,
		}),
	);
};
